export default __webpack_public_path__ + "static/media/mentalHealth2.ebd52812.jpeg";